import { createSelector } from "@reduxjs/toolkit";

export const selectUrlSubdirectory = (state) => state?.routingState?.urlSubdirectory;
export const selectUrlLocation = (state) => state?.routingState?.urlLocation;
export const selectUrlPagination = (state) => state?.routingState?.urlPaging;
export const selectUrlQueryString = (state) => state?.routingState?.urlQueryString;
export const selectNextPageUrl = (state) => state?.routingState?.nextPageUrl;
export const selectBuilderName = (state) => state?.routingState?.urlBuilderName;
export const selectPreviousPageUrl = (state) => state?.routingState?.previousPageUrl;
export const selectCurrentUrl = (state) => state?.routingState?.currentUrl;
export const selectRoutingState = (state) => state?.routingState;
export const selectMapCoordinatesQueryString = (state) => state?.routingState?.urlCoordinatesQueryString;

export const urlComponentsSelector = createSelector(
  selectUrlSubdirectory,
  selectUrlLocation,
  selectUrlPagination,
  selectUrlQueryString,
  selectBuilderName,
  selectMapCoordinatesQueryString,
  (urlSubdirectory, urlLocation, urlPaging, urlQueryString, urlBuilderName, urlCoordinatesQueryString) => ({
    urlSubdirectory,
    urlLocation,
    urlPaging,
    urlQueryString,
    urlBuilderName,
    urlCoordinatesQueryString,
  })
);

export const urlFilterSelector = createSelector(
  selectUrlQueryString,
  selectUrlSubdirectory,
  (queryStringParameter, urlSubdirectory) => ({
    queryStringParameter,
    urlSubdirectory
  })
);